import React from 'react'
import classNames from 'classnames'
import Flag from '@dustin-web/microsite-components/src/flag'

type FlagConfig = {
  href: {
    b2b?: string
  }
  ariaLabel: string
}
const FLAGS: Record<string, FlagConfig> = {
  SWE: {
    href: {
      b2b: 'https://www.dustin.se',
    },
    ariaLabel: 'swedish',
  },
  NOR: {
    href: {
      b2b: 'https://www.dustin.no',
    },
    ariaLabel: 'norwegian',
  },
  DNK: {
    href: {
      b2b: 'https://www.dustin.dk',
    },
    ariaLabel: 'danish',
  },
  FIN: {
    href: {
      b2b: 'https://www.dustin.fi',
    },
    ariaLabel: 'finnish',
  },
  NLD: {
    href: {
      b2b: 'https://www.dustin.nl',
    },
    ariaLabel: 'netherlandish',
  },
  BEL: {
    href: {
      b2b: 'https://www.dustin.be',
    },
    ariaLabel: 'belgian',
  },
}

type FlagLinkProps = {
  country: keyof typeof FLAGS
  last?: boolean
}

export const FlagLink = ({ country, last }: FlagLinkProps) => {
  const flag = FLAGS[country]
  const href = flag?.href?.b2b
  if (!flag || !href) return null

  return (
    <a
      aria-label={flag.ariaLabel || ''}
      className={classNames('a-img d-inline-block u-button-opacity', {
        'u-mr-12': !last,
      })}
      href={href}>
      <Flag countryKey={country}></Flag>
    </a>
  )
}
